export enum SnmpAuthentication {
    MD5,
    SHA,
    SHA256,
    SHA384,
    SHA512
}